import React, { useEffect } from 'react';
import Slider from "react-slick";
import lozad from 'lozad';

export const Clients = () => {
  // const initLazyLoad = () => {
  //   const observer = lozad('.lozad', {
  //     loaded: function(el) {
  //       // Custom function to handle loaded elements, if needed
  //     }
  //   });
  //   observer.observe();
  // };

  // useEffect(() => {
  //   initLazyLoad(); // Initialize lazy loading
  //   window.addEventListener('load', initLazyLoad); // Call initLazyLoad after page refresh

  //   return () => {
  //     window.removeEventListener('load', initLazyLoad); // Remove event listener on component unmount
  //   };
  // }, []);

  const Settings = {
    dots: false,
    arrows: false,
    lazyLoad: 'ondemand',
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 6, // Show 4 products at a time
    slidesToScroll: 1,

    responsive: [
        {
          breakpoint: 1181,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            
          }
        },
        {
          breakpoint: 821,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2 ,
            slidesToScroll: 1
          }
        }
      ]
};
  return (
    <section className="clients bg-1 py-4">
      <div className="container">
        <div className="row justify-content-center align-items-center">
        <Slider {...Settings}>
          
            <div className="client">
              <img src="images/client-1.png"   alt="client images" />
            </div>
            <div className="client">
              <img src="images/client-2.png"   alt="client images" />
            </div>
            <div className="client">
              <img src="images//client-3.png"    alt="client images" />
            </div>
            <div className="client">
              <img src="images/client-4.png"   alt="client images" />
            </div>
            <div className="client">
              <img src="images/client-5.png"   alt="client images" />
            </div>
            <div className="client">
              <img src="images/client-6.png"   alt="client images" />
            </div>
            <div className="client">
              <img src="images/client-1.png"   alt="client images" />
            </div>
            <div className="client">
              <img src="images/client-2.png"   alt="client images" />
            </div>
            <div className="client">
              <img src="images/client-3.png"   alt="client images" />
            </div>
            <div className="client">
              <img src="images/client-4.png"   alt="client images" />
            </div>
            <div className="client">
              <img src="images/client-5.png"   alt="client images" />
            </div>
            <div className="client">
              <img src="images/client-6.png"   alt="client images" />
            </div>
            
          </Slider>
        </div>
      </div>
    </section>
  );
};